import React from 'react';
import { useTranslation } from 'react-i18next';
import discoverImage from '../../../assets/images/discover.png';
import { Link } from 'react-router-dom';
import { ROUTER_LINKS } from '../../common/consts/app-keys.const';

const DiscoverRigs = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-[1080px] mx-auto px-6 md:px-10 pb-24 pt-0">
      <div className="bg-surface-base border border-border-dark/[0.11] rounded-[22px] overflow-hidden grid grid-cols-1 md:grid-cols-2 shadow-[0_4px_16px_rgba(0,0,0,0.08),0_1px_4px_rgba(0,0,0,0.04)] relative">
        {/* Gradient accent stripe at top — matches the hover stripe on the feature cards */}
        <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-blue to-transparent" />

        <div className="min-h-[280px] md:min-h-[340px] bg-gradient-to-br from-[var(--characters-card-gradient-0)] to-[var(--characters-card-gradient-100)] flex items-center justify-center overflow-hidden">
          <img
            src={discoverImage}
            alt="Rigs library"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-10 md:py-[52px] md:px-[52px] flex flex-col justify-center">
          <div className="font-mono text-[10px] tracking-[0.16em] uppercase text-blue mb-3">
            {t('library.label')}
          </div>
          <h2 className="font-display font-bold text-[28px] md:text-[32px] tracking-[-0.03em] leading-[1.15] text-content-dark mb-3.5">
            {t('library.title')}
          </h2>
          <p className="text-sm text-content-muted-alt leading-[1.7] mb-8 max-w-xs">
            {t('library.description')}
          </p>
          <Link
            to={ROUTER_LINKS.MODELS}
            className="inline-flex items-center gap-2 bg-transparent text-content-dark text-sm font-medium py-3 px-[22px] rounded-full border-[1.5px] border-border-dark/[0.11] no-underline transition-all duration-200 w-fit shadow-[0_1px_3px_rgba(0,0,0,0.07),0_1px_2px_rgba(0,0,0,0.05)] hover:border-blue hover:text-blue-deep-1 hover:bg-surface-hover hover:shadow-[0_0_0_3px_rgba(14,165,201,0.1)]"
          >
            {t('library.explore')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DiscoverRigs;
